(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kb-header"] && !Shopify.designMode) return;
  try {
    

function kbInitialize(root=document){
root.querySelectorAll('[data-kb-rate-switch]').forEach(switcher=>{if(switcher.dataset.ready)return;switcher.dataset.ready='true';switcher.hidden=false;const region=switcher.closest('[data-kb-rates]');const buttons=[...switcher.querySelectorAll('button')];function select(value){buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.group===value)));region.querySelectorAll('[data-kb-rate-group]').forEach(g=>g.hidden=g.dataset.kbRateGroup!==value)}buttons.forEach(b=>b.addEventListener('click',()=>select(b.dataset.group)));select('resident')});
const plan=new URLSearchParams(location.search).get('plan');const form=document.getElementById('KnockoutsApplication');if(form&&plan){const select=form.querySelector('[name="contact[Membership interest]"]');if(select&&[...select.options].some(o=>o.value===plan))select.value=plan}
root.querySelectorAll('.kb-mobile-menu nav a').forEach(a=>a.addEventListener('click',()=>a.closest('details').removeAttribute('open')));
document.querySelectorAll('.kb-mobile-menu').forEach(d=>d.addEventListener('keydown',e=>{if(e.key==='Escape'){d.open=false;d.querySelector('summary').focus()}}));
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>kbInitialize());else kbInitialize();document.addEventListener('shopify:section:load',event=>kbInitialize(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kb-membership-product"] && !Shopify.designMode) return;
  try {
    
function kbMembershipSetup(){const form=document.getElementById('KBMembershipPurchase');if(!form||form.dataset.ready)return;form.dataset.ready='true';const plan=form.querySelector('#kb-member-variant');const age=form.querySelector('#kb-member-age');const guardian=form.querySelector('#kb-member-guardian');const price=document.querySelector('[data-kb-member-price]');const help=form.querySelector('#kb-member-age-help');const guardianRequired=()=>{guardian.required=age.value!==''&&Number(age.value)<18;};const update=()=>{const option=plan.selectedOptions[0];if(!option)return;price.textContent=option.dataset.price;age.min=option.dataset.ageMin;age.max=option.dataset.ageMax;help.textContent=option.dataset.ageHelp;guardianRequired();};plan.addEventListener('change',update);age.addEventListener('input',guardianRequired);update();}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',kbMembershipSetup);else kbMembershipSetup();document.addEventListener('shopify:section:load',kbMembershipSetup);

  } catch(e) { console.error(e); }
})();
})();
